var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4374 15.9998L13.7241 20.7145C13.4812 20.966 13.3468 21.3028 13.3498 21.6524C13.3529 22.002 13.4931 22.3364 13.7403 22.5836C13.9875 22.8308 14.322 22.971 14.6715 22.9741C15.0211 22.9771 15.3579 22.8427 15.6094 22.5998L21.2667 16.9425C21.5167 16.6925 21.6571 16.3534 21.6571 15.9998C21.6571 15.6463 21.5167 15.3072 21.2667 15.0572L15.6094 9.39984C15.3579 9.15696 15.0211 9.02257 14.6715 9.02561C14.322 9.02864 13.9875 9.16887 13.7403 9.41608C13.4931 9.66329 13.3529 9.99771 13.3498 10.3473C13.3468 10.6969 13.4812 11.0337 13.7241 11.2852L18.4374 15.9998ZM16.0001 29.3332C8.63608 29.3332 2.66675 23.3638 2.66675 15.9998C2.66675 8.63584 8.63608 2.6665 16.0001 2.6665C23.3641 2.6665 29.3334 8.63584 29.3334 15.9998C29.3334 23.3638 23.3641 29.3332 16.0001 29.3332Z",
    fill: "#0944CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleArrowRight);
export default __webpack_public_path__ + "static/media/circleArrowRight.d583eea8ef816b3af2f9e05afa6359b8.svg";
export { ForwardRef as ReactComponent };